import { GetStaticPropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Favorite from '../../../features/favorite';
import { getFilterOptions, getFooterLinks } from '../../../new-lib/apis';
import { wrapper } from '../../../redux/store';
import {
  setExperimentVariant,
  setIsMobile
} from '../../../redux/actions/appActions';
import { Environments } from '../../../new-lib/Environments';
import { StaticPagesUtility } from '../../../new-lib/utilities/static-pages.utility';
import { ConfigsApis } from '../../../new-lib/apis/configs.apis';

export default function Favorites() {
  return <Favorite />;
}

export const getStaticProps = wrapper.getStaticProps(
  store =>
    async ({ params, locale }: GetStaticPropsContext) => {
      const [footerLinks, configVariables, filterOptions] = await Promise.all([
        getFooterLinks(locale, 'favorites'),
        ConfigsApis.getConfigs(locale),
        getFilterOptions(locale)
      ]);

      store.dispatch(setIsMobile(params?.device === 'mobile'));
      store.dispatch(setExperimentVariant(params?.variant as string));

      return {
        revalidate: 60 * 60 * 24,
        props: {
          ...(await serverSideTranslations(locale as string, [
            'favorite',
            'common',
            'contact',
            'search',
            'compare'
          ])),
          filterOptions: JSON.stringify(filterOptions) || '',
          configVariables,
          layout: {
            footerLinks,
            url: `${process.env.NEXT_PUBLIC_HOST}/favorites`,
            path: 'favorites'
          }
        }
      };
    }
);

export async function getStaticPaths() {
  return { paths: StaticPagesUtility.get(), fallback: false };
}
